<template>
  <data-loader>
    <dental-flashcard v-if="isDentalSimulation" />
    <default-flashcard v-else />
  </data-loader>
</template>

<script>
import DataLoader from '@/components/sims/DataLoader.vue';
import DentalFlashcard from '@/components/sims/dental/DentalFlashcard.vue';
import DefaultFlashcard from '@/components/sims/flashcards/DefaultFlashcard.vue';
import WuxSimulationsMixin from '@/mixins/wux-simulations';

export default {
  components: {
    DataLoader,
    DefaultFlashcard,
    DentalFlashcard,
  },
  mixins: [WuxSimulationsMixin],
};
</script>

<style lang='scss' scoped>
</style>
